import React, { useEffect } from "react";
import { auth } from "../config/firebase.js";
import GoogleAnalytics from '../analyticsComponents/GoogleAnalytics.js';

const Auth = ({ onUserChange }) => {
  // Firebase listener for auth changes
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      onUserChange(user); // send user to parent
    });
    return () => unsubscribe();
  }, [onUserChange]);

  return (
    <GoogleAnalytics page="AuthenticationPage" eventType="authentication_page" />
  );
};

export default Auth;
